import { createAdministrationRoutes } from '@gat-ship/administration'
import { createAuthRoutes, authRouteGuard } from '@gat-ship/auth'
import { createRouter, createWebHistory } from 'vue-router'
import { createSupportRoutes } from '@gat-ship/support'
import { PageNotFound } from '@gat-ship/vue-components'
import { createStakeholderRoutes } from '@gat-ship/stakeholder-search'
import { createMailRoutes } from '@gat-ship/mail-test'
import { createWhiteboardRoutes } from '@gat-ship/whiteboard'
import './app-route-types'

const appRouter = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: () => '/portcalls'
    },
    ...createAdministrationRoutes('/admin'),
    ...createSupportRoutes('/support'),
    ...createStakeholderRoutes('/stakeholders'),
    ...createMailRoutes('/mail'),
    ...createWhiteboardRoutes('/portcalls'),

    // https://router.vuejs.org/guide/migration/#Removed-star-or-catch-all-routes
    // pathMatch is the name of the param, e.g., going to /not/found yields
    // { params: { pathMatch: ['not', 'found'] }}
    // this is thanks to the last *, meaning repeated params and it is necessary if you
    // plan on directly navigating to the not-found route using its name
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: PageNotFound
    },
    // if you omit the last `*`, the `/` character in params will be encoded when resolving or pushing
    {
      path: '/:pathMatch(.*)',
      name: 'bad-not-found',
      component: PageNotFound
    },
    ...createAuthRoutes({
      RouteName: {
        loggedOut: 'logged-out',
        oAuth2Callback: 'auth-o-auth-callback',
        signIn: 'auth-sign-in',
        signOut: 'auth-sign-out'
      }
    })
  ]
})

appRouter.beforeEach(authRouteGuard)

export default appRouter
